import { useEffect, useState } from "react";
import { useBranding, resolveLogoSrc } from "@/context/BrandingContext";

/** Renders the brand logo, falling back to the brand title text when no logo is
 *  configured or the image fails to load. */
export function Brand({ className = "h-14 w-auto", textClassName = "font-heading text-xl font-bold tracking-tight" }) {
  const { brandTitle, logoUrl } = useBranding();
  const [broken, setBroken] = useState(false);
  const src = resolveLogoSrc(logoUrl);

  useEffect(() => { setBroken(false); }, [src]);

  if (!src || broken) {
    return <div className={textClassName} data-testid="brand-title-text">{brandTitle}</div>;
  }
  return (
    <img src={src} alt={brandTitle} className={className}
      onError={() => setBroken(true)} data-testid="brand-logo-img" />
  );
}
